import { render, staticRenderFns } from "./EditBasicDetails.vue?vue&type=template&id=56affda5&"
import script from "./EditBasicDetails.vue?vue&type=script&lang=js&"
export * from "./EditBasicDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditBasicDetails.vue?vue&type=style&index=0&id=56affda5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports